


































import { defineComponent, computed } from "vue";
import { Store } from "vuex";
import SlcBatchSelect from "@/components/SlcCollab/parts/SlcCollabBatchSelect.vue";
import SlcAddToListBtn from "@/components/SlcCollab/parts/SlcCollabAddToListBtn.vue";
import SlcClearSelectionBtn from "@/components/SlcCollab/parts/SlcCollabClearSelectionBtn.vue";
import SlcItemCounter from "@/components/SlcCollab/parts/SlcCollabItemCounter.vue";
import SlcListModalBtn from "@/components/SlcCollab/parts/SlcCollabListModalBtn.vue";
import SlcCreateNewListBtn from "@/components/SlcCollab/parts/SlcCollabCreateNewListBtn.vue";
import store from "@/store";
import maxZIndex from "@/views/lib/useMaxZIndex";

export default defineComponent({
  components: {
    SlcBatchSelect,
    SlcAddToListBtn,
    SlcCreateNewListBtn,
    SlcClearSelectionBtn,
    SlcItemCounter,
    SlcListModalBtn
  },
  setup() {
    const isEnabled = computed(
      () => store.getters["collaboration/isSelectionEnabled"]
    );
    const collaboration = computed(
      () => (store as Store<any>).state.collaboration
    );
    const canAddToList = computed(
      () =>
        collaboration.value.isSidebarVisible &&
        collaboration.value.selectedFolder
    );
    return { isEnabled, canAddToList, maxZIndex };
  }
});
